import { render, staticRenderFns } from "./SameFiltersModal.vue?vue&type=template&id=2d7ccf9a"
import script from "./SameFiltersModal.vue?vue&type=script&lang=js"
export * from "./SameFiltersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports